<template>
    <div></div>
</template>

<script>
/* global gtag */
import vue from 'vue';
import axios from '../axios-config';

export default {
  mounted() {
    const self = this;

    setTimeout(function () {
      if (process.env.IS_OKTA_LOGIN_ENABLED) {
        vue.prototype.$security.signOut();
      } else {
        axios.post('logout', {
          token: sessionStorage.getItem('refresh_token'),
        }).then().catch((error) => {
          window.console.warn('An error occurred while logging out:', error.message);

          gtag('event', 'exception', {
            description: 'Error logging out',
            fatal: false, // set to true if the error is fatal
          });
        }).then(() => {
          /* eslint func-names:  */
          /* eslint prefer-arrow-callback: */
          // this.$router.push('/');
          sessionStorage.setItem('epic', null);
          sessionStorage.setItem('epicSuccessAlertWasShown', null);
          sessionStorage.setItem('redirectedFromEpicImport', null);
          self.$store.commit('clearSessionData');
          self.$store.dispatch('agentLogout', false);
          /**
           * TODO: Refactor: Implement this either with async/await or chained promises
           * to avoid `setTimeout()` which can cause race conditions.
           */
          window.location.href = '/';
        });
      }
    }, 500);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Intermediate.vue?583beaf9